import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { ErrorImage } from '@images';
import { StyledStateContainer } from '@styles/app.styles';
import { __ } from '@utils/i18n';

const ErrorLayout = () => (
	<StyledStateContainer>
		<ErrorImage />

		<Box sx={{ maxWidth: '300px' }}>
			<Typography variant="h5" align="center" sx={{ mb: 2 }}>
				{__('Well this is unexpected…')}
			</Typography>

			<Typography variant="body2" align="center">
				{__(
					'We ran into a technical glitch and are working right now to fix it. Please try again later.',
				)}
			</Typography>
		</Box>
	</StyledStateContainer>
);

export default ErrorLayout;
